import React from 'react';
import "../../config.js";
import AppHeader from '../header/AppHeader.js';

const App404 = (props) => {
    return (
        <div>
            <AppHeader appHeaderTitle={global.constants.const_app_not_found} appHeaderUrl="" />
            <h2>404</h2>
        </div>
    );
}

export default (datasource) => <App404 datasource={datasource} />;
